(function () {
  var GA4_EVENT_DEBUG = true;
  var GA4_MEASUREMENT_ID = "G-NZMS9M7VHH";
  var configured = false;

  function debug() {
    if (!GA4_EVENT_DEBUG || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[ga4-event]");
    console.log.apply(console, args);
  }

  function isGaDebugUrl() {
    try {
      return new URL(window.location.href).searchParams.has("ga_debug");
    } catch (e) {
      return false;
    }
  }

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  function ensureConfigured() {
    if (configured) return;
    var config = { send_page_view: false };
    if (isGaDebugUrl()) config.debug_mode = true;
    window.gtag("js", new Date());
    window.gtag("config", GA4_MEASUREMENT_ID, config);
    configured = true;
    debug("configured", GA4_MEASUREMENT_ID, config);
  }

  window.fireGa4Event = function (eventName, params) {
    params = params || {};
    ensureConfigured();
    window.gtag("event", eventName, params);
    debug("sent:", eventName, params);
  };
})();
